import * as React from "react";
const SvgTextBoldFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.89 3a5.11 5.11 0 0 1 4.602 7.336 5.803 5.803 0 0 1-3.294 10.578H7a2 2 0 0 1-.97-.251C5.415 20.34 5 19.723 5 19.012V4.889C5 3.852 5.885 3.01 6.98 3h5.91", clipRule: "evenodd" }));
export default SvgTextBoldFill;
